// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"bc62f1f3","282":"1d156b35","364":"18e44530","596":"b2fa2f44","833":"682d5ea0","838":"b714bf4f","929":"0f49248c"}[chunkId] + ".chunk.js";
};